import * as React from 'react';

const MiniClock = (props) => (
  <svg
    width={props.width}
    height={props.height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.999 15.167A7.173 7.173 0 0 1 .832 8 7.173 7.173 0 0 1 7.999.833 7.173 7.173 0 0 1 15.165 8 7.173 7.173 0 0 1 8 15.167Zm0-13.334A6.174 6.174 0 0 0 1.832 8c0 3.4 2.767 6.167 6.167 6.167S14.165 11.4 14.165 8 11.4 1.833 8 1.833Z"
      fill={props.fill}
    />
    <path
      d="M10.475 10.62a.446.446 0 0 1-.253-.073L8.155 9.313c-.513-.306-.893-.98-.893-1.573V5.007c0-.273.226-.5.5-.5.273 0 .5.227.5.5V7.74c0 .24.2.594.406.713l2.067 1.234a.5.5 0 0 1 .173.687.514.514 0 0 1-.433.246Z"
      fill={props.fill}
    />
  </svg>
);

MiniClock.defaultProps = {
  width: 16,
  height: 16,
  fill: '#475569',
};

export { MiniClock };
